/**
 * 주요 검색엔진 및 크롤러 패턴 목록
 */
const CRAWLER_PATTERNS = [
  // 주요 검색엔진 봇
  'googlebot',
  'google-ads-bot',
  'google-site-verification',
  'bingbot',
  'bingpreview',
  'slurp', // Yahoo
  'duckduckbot',
  'baiduspider',
  'yandexbot',
  'yeti', // Naver - https://searchadvisor.naver.com/guide/seo-basic-firewall

  // 소셜미디어 크롤러
  'facebookexternalhit',
  'twitterbot',
  'linkedinbot',
  'telegrambot',
  'whatsapp',
  'kakaotalk-scrap',

  // 일반적인 봇/크롤러 패턴
  'bot',
  'crawler',
  'spider',
  'scraper',
  'crawl',
] as const

/**
 * User-Agent 문자열을 분석하여 검색엔진 크롤러인지 감지합니다.
 *
 * @param userAgent - 분석할 User-Agent 문자열 (선택적)
 * @returns 크롤러로 판단되면 true, 아니면 false
 *
 * @example
 * ```typescript
 * detectSearchEngineCrawler('Mozilla/5.0 (compatible; Googlebot/2.1; +http://www.google.com/bot.html)')
 * // returns true
 *
 * detectSearchEngineCrawler('Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36')
 * // returns false
 *
 * detectSearchEngineCrawler() // undefined userAgent
 * // returns false
 * ```
 */
export function detectSearchEngineCrawler(userAgent?: string): boolean {
  const cleanedUserAgent = (userAgent || '').toLowerCase().trim()

  // 빈 문자열이나 매우 짧은 문자열은 일반 사용자로 간주
  if (!cleanedUserAgent || cleanedUserAgent.length < 3) {
    return false
  }

  return CRAWLER_PATTERNS.some((pattern) => cleanedUserAgent.includes(pattern))
}
